"use client";

import { useEffect } from "react";

export default function GlobalError({ error, reset }) {
  useEffect(() => {
    console.error("[GlobalError]", error);
  }, [error]);

  return (
    <html>
      <body>
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#FAFAFA",
            fontFamily: "system-ui, -apple-system, sans-serif",
          }}
        >
          <div
            style={{
              maxWidth: 480,
              width: "100%",
              margin: "0 20px",
              padding: 32,
              backgroundColor: "white",
              borderRadius: 16,
              boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
              textAlign: "center",
            }}
          >
            <div
              style={{
                width: 64,
                height: 64,
                borderRadius: 32,
                backgroundColor: "#FEF2F2",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 16px",
                fontSize: 28,
              }}
            >
              ⚠️
            </div>
            <h2
              style={{
                fontSize: 20,
                fontWeight: 600,
                color: "#111827",
                margin: "0 0 8px",
              }}
            >
              Something went wrong
            </h2>
            <p
              style={{
                fontSize: 14,
                color: "#6B7280",
                margin: "0 0 24px",
                lineHeight: 1.5,
              }}
            >
              Please try again. If the problem continues, contact support with
              what you were doing when this appeared.
            </p>
            <button
              onClick={() => reset()}
              style={{
                padding: "10px 24px",
                fontSize: 14,
                fontWeight: 500,
                color: "white",
                backgroundColor: "#111827",
                border: "none",
                borderRadius: 8,
                cursor: "pointer",
                marginRight: 8,
              }}
            >
              Try Again
            </button>
            <button
              onClick={() => (window.location.href = "/")}
              style={{
                padding: "10px 24px",
                fontSize: 14,
                fontWeight: 500,
                color: "#374151",
                backgroundColor: "#F3F4F6",
                border: "1px solid #D1D5DB",
                borderRadius: 8,
                cursor: "pointer",
              }}
            >
              Go Home
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
